import React, {useContext, useEffect, useState} from 'react';
import {Scrollbars} from "react-custom-scrollbars";
import InputSourceCard from "./AddColumns/InputSourceCard";
import Styles from "./AddColumns/AddColumns.module.scss"
import AddRemoveInput from "./AddColumns/AddRemoveInput";
import ConnectorHeader from "./Components/ConnectorHeader";
import dataConnectorContext from "./context/dataConnectorContext";
import http from "../../services/api/utilities/http";


export default function AddColumns(props) {
    const context = useContext(dataConnectorContext)
    const [selectedColumnsName, setSelectedColumnsName] = useState([])
    const [selectedColumns, setSelectedColumns] = useState({})
    const [extra_columns, setExtra_columns] = useState({})
    const [allColumns, setAllColumns] = useState([])
    const [columns, setColumns] = useState(false)
    const [selectedSource ,setSelectedSource] = useState(0)
    const [added, setAdded] = useState([])
    useEffect(() => {
        getColumns()
    }, [])
    const getColumns = () => {
        http.get(`data_connector/data_pool_handler/${context.state.connectorUid}/columns/`)
            .then(res => {
                let selectedColumnsName = [], newAdd = [],extra = {}
                let {all_columns, selected_columns, extra_columns} = res.data.data
                Object.keys(selected_columns).map(col => {
                    selectedColumnsName = selectedColumnsName.concat(selected_columns[col]['column'])
                })
                Object.keys(extra_columns).map(col => {
                    newAdd = newAdd.concat(extra_columns[col]['column'])
                })
                console.log('mohsen',res.data.data)
                setAdded(newAdd)
                extra_columns.forEach(item => {
                    extra[item.column] = item
                })
                setExtra_columns(extra)
                setSelectedColumnsName(selectedColumnsName)
                setAllColumns(all_columns)
                setColumns(all_columns[0])
                setSelectedColumns(selected_columns)
            })
            .catch(err => {
                console.log(err.response)
            })
    }
    const addExtraColumns = () => {
        console.log('extra',extra_columns)
        context.dispatch({type:'set_add_columns',value:extra_columns})
        let extraColumns = [], extra = []
        Object.keys(extra_columns).map(col => {
            extraColumns.push(extra_columns[col])
        })
        http.post(`data_connector/data_pool_handler/${context.state.connectorUid}/extra_columns/`
            , {extra_columns: extraColumns})
            .then(res => {
                console.log(res)
                context.dispatch({type:'set_page',value:'Data Preview'})
            })
            .catch(err => {
                console.log(err)
                context.dispatch({type:'set_page',value:'Data Preview'})
            })
    }
    const addOrRemoveCol = (id, source, column, type, add) => {
        let newAdd = added , ex = extra_columns
        if (add === 'add') {
            ex[column] = {column,id,source,type}
            newAdd = newAdd.concat(column)
            setAdded(newAdd)
            console.log(ex)
            setExtra_columns(ex)
        } else {
            if (newAdd.indexOf(column) > -1) {
                delete ex[column]
                newAdd = newAdd.filter(col => col !== column)
                setAdded(newAdd)
                setExtra_columns(ex)
            }
        }
    }

    const hr = {
        width: 'calc(100% + 64px)',
        height: 1,
        position: 'relative',
        left: -32,
        bottom: 0,
        background: '#F0F2FF',
    }
    return (
        <div>
            <ConnectorHeader title="Upload File - Eventlog Creation - Edit Columns">
                If your file is already an eventlog just edit the columns if we’re mistaken. If you don’t have an
                eventlog you can create right here!
            </ConnectorHeader>
            <div className={Styles.selectedColumnsRow}>
                <p className="f14 fw500 dark-gary-2 mt-3">Selected Columns</p>
                <div className={Styles.ulWrapper}>
                    <ul className={Styles.template}>
                        {Object.keys(selectedColumns).map((col, key) => (
                            <li key={key}>
                                {selectedColumns[col]['column']}
                            </li>
                        ))}
                        {Object.keys(extra_columns).map((col, key) => (
                            <li key={key}>
                                {extra_columns[col]['column']}
                            </li>
                        ))}
                    </ul>
                </div>
                <div style={hr}></div>
            </div>
            <div className="d-flex mt-24">
                <div>
                    <label className="mb-24 dark-gary-2 f14 fw700">Uploaded Sources</label>
                    {allColumns.map((col, key) => (
                        <div key={key} onClick={() => setSelectedSource(key)}>
                            <InputSourceCard  active={selectedSource === key} setColumns={setColumns} col={col}/>
                        </div>
                    ))}
                </div>
                <div className="ml-1 w-100">
                    <div>
                        <label className="f14 fw400 dark-gary-2">Columns</label>
                        <p className="f12 fw400 gray">Localhost <span className="f14 fw700 gray">/ {columns.source}</span></p>
                    </div>
                    <div className={`${Styles.columnsWrapper} d-flex`}>

                        <div className={`${Styles.columns} d-flex flex-column flex-wrap`}>
                            {columns && columns.columns.map((name, key) => (
                                <AddRemoveInput
                                    key={key}
                                    added={added}
                                    name={name}
                                    columns={columns}
                                    addOrRemoveCol={addOrRemoveCol}
                                    type={(selectedColumnsName.includes(name) || added.includes(name)) ? 'remove' : 'add'}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex mt-40 justify-content-between">
                <div onClick={addExtraColumns} className="btn">Save</div>
            </div>
        </div>
    );
}
